import { X } from "lucide-react";

/**
 * Fullscreen image viewer for alert photos. Click outside or the close
 * button to dismiss.
 */
export default function AlertImageLightbox({ src, index, total, onClose }) {
  return (
    <div
      className="fixed inset-0 z-[1200] bg-black/85 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="alert-image-lightbox"
    >
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        className="absolute top-4 right-4 w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center"
        aria-label="Close"
      >
        <X className="w-5 h-5" />
      </button>
      <img
        src={src}
        alt={`Photo ${index + 1} of ${total}`}
        className="max-w-full max-h-full object-contain rounded-sm"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}
